import BasePerimeter from './BasePerimeter';

export default new BasePerimeter({
  purpose: 'contact',

  can: {
    all() {
      return this.hasPermission('contact-read');
    },

    create() {
      return this.hasPermission('contact-write');
    },

    read() {
      return this.hasPermission('contact-read');
    },

    update(contact) {
      return this.hasPermission('contact-update') || this.isCreator(contact);
    },

    destroy() {
      return this.hasPermission('contact-delete');
    }
  },

  isCreator(contact) {
    if (!contact) return false;

    return this.child.id === contact.child_id;
  }
});
